/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUserGroup.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "common/user-group";

export class AutogenModelUserGroup<RowType extends ModelRow> extends Endpoint<RowType, RowUserGroupFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowUserGroup extends ModelRow<RowUserGroupFields> {
    constructor(values?: Partial<RowUserGroupFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowUserGroupFields {
    company_id: string;
    descr: string;
    id: string;
    user_group_type: string;
    user_type: string;
}

